import { getTestIds } from 'seagull/utils/TestIds';
export const GetContactsDashboardRowOldTID = (parentTestId)=>getTestIds(parentTestId);
export const hasPortalAccess = (contact)=>{
    if (contact.customerId() == null) return false;
    if (contact.userId() == null) return false;
    if (contact.role() == null) return false;
    if (contact.isReviewer()) return false;
    return true;
};
export const portalAccessDisabledTooltip = (param)=>{
    let { contact, clientViewTexts } = param;
    if (contact.isReviewer()) return clientViewTexts.menuItemDisabledReviewerOnly();
    return clientViewTexts.menuItemDisabledNoCustomer();
};
